import { render, staticRenderFns } from "./TransferCaseModal.vue?vue&type=template&id=c38bd216&scoped=true&"
import script from "./TransferCaseModal.vue?vue&type=script&lang=js&"
export * from "./TransferCaseModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferCaseModal.vue?vue&type=style&index=0&id=c38bd216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38bd216",
  null
  
)

export default component.exports